import { FC, Dispatch, SetStateAction } from 'react'
import StandardInput from 'src/components/basic/StandardInput'
import {
  FormContainer,
} from 'src/components/application/defaultComponents'
import {
  FlexDiv
} from 'src/components/application/formComponents/styles'
import FormItemComponent from '../../formComponents/QuestionItemGeneralLayout'
import OptionButtons from '../../formComponents/OptionButtons'
import { JudgePastLiabilityData } from 'src/dtos/applicationData'
import { LeftBar } from 'src/components/basic/LeftBar'
import ReminderCard from 'src/components/basic/ReminderCard'
import { ValidationErrorMessage } from 'src/components/basic/ValidationErrorMessage/ValidationErrorMessage'

interface Props {
  pastLiability?: JudgePastLiabilityData;
  setPastLiability: Dispatch<SetStateAction<JudgePastLiabilityData | undefined>>;
  isIncorrect: boolean;
  validatedFields: string[];
}

const BasicForm: FC<Props> = ({
  pastLiability,
  setPastLiability,
  isIncorrect,
  validatedFields
}) => {

  return (
    <FormContainer maxWidth='100%' style={{marginTop: '96px'}}>
      <FlexDiv gap="160px" dir="column">
        <FormItemComponent
          step={1}
          title='Has the applicant ever had similar insurance canceled, declined or non-renewed?'
          maxWidth='100%'
          isValid={!validatedFields.includes('step1')}
        >
          <OptionButtons
            option={pastLiability?.hasInsuranceDeclined}
            setOption={(option) => setPastLiability(prev => ({...prev, hasInsuranceDeclined: option}))}
            isIncorrect={isIncorrect}
            errorCode='EC177'
          />
          <ValidationErrorMessage errorCode='EC177' />
          {pastLiability?.hasInsuranceDeclined === true ? (
            <FlexDiv gap="24px">
              <LeftBar />
              <StandardInput
                label="Please provide details"
                rows={6}
                value={pastLiability?.insuranceDeclinedDetails ?? ''}
                onChange={({ target: { value }}) => setPastLiability(prev => ({ ...prev, insuranceDeclinedDetails: value }))}
                isIncorrect={isIncorrect && !pastLiability?.insuranceDeclinedDetails}
                errorMessage={(isIncorrect && !pastLiability?.insuranceDeclinedDetails) ? 'This is a required field' : ''}
                errorCode='EC178'
              />
            </FlexDiv>
          ) : null}
        </FormItemComponent>
        <FormItemComponent
          step={2}
          title='Has the applicant ever had any professional liability claims asserted or action filed against him or her, or has a claim been paid on behalf of the applicant?'
          maxWidth='100%'
          isValid={!validatedFields.includes('step2')}
        >
          <OptionButtons
            option={pastLiability?.hasClaimsAsserted}
            setOption={(option) => setPastLiability(prev => ({...prev, hasClaimsAsserted: option}))}
            isIncorrect={isIncorrect}
          />
          {pastLiability?.hasClaimsAsserted === true ? (
            <FlexDiv maxWidth='460px'>
              <ReminderCard
                icon='bulb'
                withLeftBar
                title="Additional Information Required"
              >
                You will need to fill out additional claim information on the next page regarding this answer.
              </ReminderCard>
            </FlexDiv>
          ) : null}
        </FormItemComponent>
        <FormItemComponent
          step={3}
          title='Has the applicant ever been reprimanded or refused admission to practice before any court or administrative agency or otherwise been disbarred or had his or her rights to practice suspended (including voluntary suspension)?'
          maxWidth='100%'
          isValid={!validatedFields.includes('step3')}
        >
          <OptionButtons
            option={pastLiability?.hasBeenRefused}
            setOption={(option) => setPastLiability(prev => ({...prev, hasBeenRefused: option}))}
            isIncorrect={isIncorrect}
          />
          {pastLiability?.hasBeenRefused === true ? (
            <FlexDiv gap="24px">
              <LeftBar />
              <StandardInput
                label="Please provide details"
                rows={6}
                value={pastLiability?.refusedDetails ?? ''}
                onChange={({ target: { value }}) => setPastLiability(prev => ({ ...prev, refusedDetails: value }))}
                isIncorrect={isIncorrect && !pastLiability?.refusedDetails}
                errorMessage={(isIncorrect && !pastLiability?.refusedDetails) ? 'This is a required field' : ''}
                errorCode='EC299'
              />
            </FlexDiv>
          ) : null}
        </FormItemComponent>
        <FormItemComponent
          step={4}
          title='Has the applicant ever been reprimanded or had his or her rights to serve as a judge suspended (including voluntary suspension)?'
          maxWidth='100%'
          isValid={!validatedFields.includes('step4')}
        >
          <OptionButtons
            option={pastLiability?.hasBeenSuspended}
            setOption={(option) => setPastLiability(prev => ({...prev, hasBeenSuspended: option}))}
            isIncorrect={isIncorrect}
          />
          {pastLiability?.hasBeenSuspended === true ? (
            <FlexDiv gap="24px">
              <LeftBar />
              <StandardInput
                label="Please provide details"
                rows={6}
                value={pastLiability?.suspendedDetails ?? ''}
                onChange={({ target: { value }}) => setPastLiability(prev => ({ ...prev, suspendedDetails: value }))}
                isIncorrect={isIncorrect && !pastLiability?.suspendedDetails}
                errorMessage={(isIncorrect && !pastLiability?.suspendedDetails) ? 'This is a required field' : ''}
                errorCode='EC300'
              />
            </FlexDiv>
          ) : null}
        </FormItemComponent>
        <FormItemComponent
          step={5}
          title='Does the applicant know of any circumstance, act, error or omission that might form the basis of a claim against the applicant?'
          maxWidth='100%'
          isValid={!validatedFields.includes('step5')}
        >
          <OptionButtons
            option={pastLiability?.hasActsToBaseClaim}
            setOption={(option) => setPastLiability(prev => ({...prev, hasActsToBaseClaim: option}))}
            isIncorrect={isIncorrect}
          />
          {pastLiability?.hasActsToBaseClaim === true ? (
            <FlexDiv maxWidth='460px'>
              <ReminderCard
                icon='bulb'
                withLeftBar
                title="Additional Information Required"
              >
                You will need to fill out additional claim information on the next page regarding this answer.
              </ReminderCard>
            </FlexDiv>
          ) : null}
        </FormItemComponent>
      </FlexDiv>
    </FormContainer>
  )
}

export default BasicForm